export default "__VITE_ASSET__ulKIw5rC__"